var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_Icon",
    "data-name": "Download Icon",
    transform: "translate(-1849 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5788",
    "data-name": "Rectangle 5788",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(1849 80)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Download",
    d: "M4865.7,12171a2.7,2.7,0,0,1-2.7-2.7v-5.4a.9.9,0,1,1,1.8,0v5.4a.9.9,0,0,0,.9.9h12.6a.9.9,0,0,0,.9-.9v-5.4a.9.9,0,0,1,1.8,0v5.4a2.7,2.7,0,0,1-2.7,2.7Zm5.957-5.471a.881.881,0,0,1-.3-.188l-3.6-3.6a.9.9,0,0,1,1.28-1.277l2.062,2.068v-8.629a.9.9,0,1,1,1.8,0v8.629l2.059-2.068a.9.9,0,0,1,1.28,0,.9.9,0,0,1,0,1.277l-3.6,3.6a.906.906,0,0,1-.98.188Z",
    transform: "translate(-2998 -12057)",
    fill: "#474b4f",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/Download Icon.a759cf6ab3432b4e9ba9e5428af5e064.svg";
export { ForwardRef as ReactComponent };